import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { SurfHeight } from '@surfline/quiver-react';
import spotProptype from '../../propTypes/spot';
import conditionClassModifier from '../../utils/conditionClassModifier';

const className = (conditions, expired) => {
  const classObject = {};
  classObject['sl-cam-list-item-spot-info__conditions'] = true;
  classObject[
    `sl-cam-list-item-spot-info__conditions--${conditionClassModifier(conditions)}`
  ] = true;
  classObject['sl-cam-list-item-spot-info__conditions--expired'] = expired;
  return classNames(classObject);
};

const CamListItemSpotInfo = ({ spot, units }) => (
  <div>
    <div className="sl-cam-list-item-spot-info__name">
      <span
        className={className(
          spot.conditions.value,
          spot.conditions.expired && spot.conditions.human
        )}
      />
      {spot.name}
    </div>
    <SurfHeight min={spot.waveHeight.min} max={spot.waveHeight.max} units={units} />
  </div>
);

CamListItemSpotInfo.propTypes = {
  spot: spotProptype.isRequired,
  units: PropTypes.string.isRequired,
};

export default CamListItemSpotInfo;
